import React, { useState, FC } from "react";

export const FooterFormMailchimp: FC<FooterFormMailchimp> = ({ slug }) => {
  const [completed, setCompleted] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [formState, setFormState] = useState({
    name: "",
    surname: "",
    email: "",
    gdprConsent: false,
  });

  // Configuración condicional según el slug
  const formConfig: Record<string, FormConfig> = {
    "san-francisco": {
      url: "https://lamarsf.us16.list-manage.com/subscribe/post?u=c93de14292489dac9d257cd0a&id=fe3b203448",
      gdprField: "gdpr[2]",
      marketingText: "Please select all the ways you would like to hear from La Mar San Francisco:",
    },
    "bellevue": {
      url: "https://lamarcebicheria.us8.list-manage.com/subscribe/post?u=a6145fb3d0320b6c8b076d0da&id=8074283287",
      gdprField: "gdpr[44090]",
      marketingText: "Please select all the ways you would like to hear from La Mar Bellevue:",
    },
  };

  const { url, gdprField, marketingText } = formConfig[slug];

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = event.target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append("EMAIL", formState.email);
    formData.append("FNAME", formState.name);
    formData.append("LNAME", formState.surname);
    if (formState.gdprConsent) formData.append(gdprField, "Y");

    fetch(url, {
      method: "POST",
      body: formData,
      mode: "no-cors",
    })
      .then(() => setCompleted(true))
      .catch((error) => console.log("Error:", error))
      .finally(() => setLoading(false));
  };

  return (
    <>
      {completed ? (
        <div className="links-section-bigger mailchimp-form">
          <p>Thank you for subscribing!</p>
          <span>You will receive information, news, and updates from the brand.</span>
        </div>
      ) : (
        <div className="links-section-bigger mailchimp-form">
          <p className="title gt-dark">Subscribe to receive updates and promotions.</p>
          <form onSubmit={handleSubmit} className="formulario">
            <div className="form-group">
              <label>
                <input
                  required
                  type="text"
                  name="name"
                  placeholder="Name"
                  className="form-control"
                  onChange={handleInputChange}
                />
              </label>
            </div>
            <div className="form-group">
              <label>
                <input
                  required
                  type="text"
                  name="surname"
                  placeholder="Surname"
                  className="form-control"
                  onChange={handleInputChange}
                />
              </label>
            </div>
            <div className="form-group">
              <label>
                <input
                  required
                  type="email"
                  name="email"
                  placeholder="Email"
                  className="form-control"
                  onChange={handleInputChange}
                />
              </label>
            </div>
            <div className="form-group bigger form-validation">
              <label>
                Marketing Permissions
                <p className="form-acceptances-text">{marketingText}</p>
              </label>
              <label className="form-label flex">
                <input
                  required
                  type="checkbox"
                  name="gdprConsent"
                  className="form-control normal"
                  onChange={handleInputChange}
                />
                <span>I have read and accept the data privacy policy of this website</span>
              </label>
              <label>
                <p className="form-acceptances-text">
                  You can unsubscribe at any time by clicking the link in the footer of our emails.
                </p>
              </label>
            </div>
            <button
              type="submit"
              className="form-button button style-primary-footer"
              disabled={loading}
            >
              {loading ? "Sending..." : "Subscribe"}
            </button>
          </form>
        </div>
      )}
    </>
  );
};
